import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const getCustomStatusContent = sourceUrl => statusCode => statusCode === 410 ? {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.expired.title"
  }),
  message: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.errorState.expired.text_jsx",
      options: {
        href: sourceUrl
      },
      elements: {
        Link
      }
    })
  })
} : null;